module.exports = __webpack_public_path__ + "static/media/msrating_105.efcbe642.ico";